import { Button, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { setEnv, useEnv, type AppEnv } from "../hooks/useEnv";

export default function EnvSwitcher() {
  const env = useEnv();

  const switchTo = (next: AppEnv) => {
    if (next === env) return;
    setEnv(next);
    // Do NOT call auth.removeUser() here — it races the navigation: clearing
    // the user state synchronously triggers ProtectedShell's auto-signinRedirect,
    // which redirects to Cognito (still has an active SSO session) and lands the
    // browser back on /signin/callback before our cross-host nav can commit.
    // The destination origin will manage its own OIDC lifecycle from scratch.
    const host = typeof window !== "undefined" ? window.location.hostname : "";
    const target =
      host.startsWith("support-prod") && next === "dev"
        ? "https://support-dev.humancreator.com/"
        : host.startsWith("support-dev") && next === "prod"
          ? "https://support-prod.humancreator.com/"
          : "/";
    window.location.href = target;
  };

  return (
    <Menu>
      <MenuButton
        as={Button}
        size="sm"
        variant={env === "prod" ? "solid" : "solid"}
        colorScheme={env === "prod" ? "red" : "green"}
        rightIcon={<ChevronDownIcon />}
      >
        Env: {env.toUpperCase()}
      </MenuButton>
      <MenuList>
        <MenuItem onClick={() => switchTo("dev")}>Dev</MenuItem>
        <MenuItem onClick={() => switchTo("prod")}>Prod</MenuItem>
      </MenuList>
    </Menu>
  );
}
